import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../../services/dashboard.service";

// Async thunks
export const getDashboardDataThunk = createAsyncThunk(
  "dashboard/getDashboardData",
  async (payload: { start_time: string }, { rejectWithValue }) => {
    try {
      const response = await api.getDashboardData(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Get dashboard data failed"
      );
    }
  }
);

export const getCallStatsThunk = createAsyncThunk(
  "dashboard/getCallStats",
  async (
    payload: {
      direction: string;
      limit: number;
      page: number;
      filter_by: string;
      start_time: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await api.getCallStats(payload);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || "Get call stats failed"
      );
    }
  }
);
